import React from 'react';
import { X, AlertCircle } from 'lucide-react';
import './Modal.css';

function ConfirmationModal({
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isWarning = false,
  isDanger = false,
  onConfirm,
  onCancel
}) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="close-btn" onClick={onCancel}>
            <X size={24} />
          </button>
        </div>

        <div className="confirm-content">
          {(isWarning || isDanger) && (
            <div className={`warning-icon ${isDanger ? 'danger' : ''}`}>
              <AlertCircle size={48} />
            </div>
          )}
          <p>{message}</p>
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-secondary" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
